// extracted by mini-css-extract-plugin
export default {"button":"Xo","primary":"Yo","fullWidth":"Zo","secondary":"ap","nutrition":"bp","underlined":"cp","small":"ep","medium":"fp","info":"gp","white":"hp","border":"ip","mango":"jp","charcoal":"kp","court":"lp","green":"mp","spark":"np","linkButton":"op","disabled":"pp"};
    if(module.hot) {
      // 1714422952763
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  